// use of IEC standard to comply with RDC in Windows
export function displayBytes(bytes: number) {
  if (bytes === Infinity) {
    return null;
  }
  const sizes = ["Bytes", "KiB", "MiB", "GiB", "TiB"];
  if (bytes === 0) return "0 Byte";
  if (bytes === 1) return "1 Byte";
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  return `${parseFloat((bytes / Math.pow(1024, i)).toFixed(2))} ${sizes[i]}`;
}
